import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative bg-dark h-[600px] lg:h-[700px] flex items-center" data-id="element-203" data-mp="ejwl1drxcj8d">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-204" data-mp="9k0g9cbeknrr">
        <img src="https://images.unsplash.com/photo-1605810230434-7631ac76ec81?q=80&w=2070&auto=format&fit=crop" alt="Ford Super Duty Truck" className="w-full h-full object-cover object-center" data-id="element-205" data-mp="9ipbpaa4vbzl" />
        <div className="absolute inset-0 bg-dark/80 mix-blend-multiply" data-id="element-206" data-mp="xanq434vpngy"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/50 to-transparent" data-id="element-207" data-mp="x8joxsyd72kd"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-208" data-mp="ncglmjrs0xvu">
        <div className="max-w-3xl" data-id="element-209" data-mp="nekkuoeqd8ps">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-5xl md:text-6xl lg:text-7xl font-display text-white leading-tight mb-6" data-id="element-210" data-mp="3d1sbr0oqzpup">
            The Palm Beach Authority in <br className="hidden md:block" data-id="element-211" data-mp="399te53cn8qcv" />
            <span className="text-orange" data-id="element-212" data-mp="3e9607lvoxtee">Powerstroke & Diesel Repair</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl leading-relaxed" data-id="element-213" data-mp="30i15my76jrax">
            Professional grade mechanical service for your truck. Specializing
            in 6.0L, 6.4L, 6.7L, and 7.3L engines. Don't settle for general
            mechanics—give your diesel the expert touch it deserves.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="flex flex-col sm:flex-row gap-4" data-id="element-214" data-mp="s334ncg7smx0">
            <a href="#appointment" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-md text-white bg-orange hover:bg-orange/90 transition-all shadow-lg shadow-orange/30 hover:shadow-orange/50 hover:-translate-y-0.5" data-id="element-215" data-mp="1b0vx1kt7peg5">
              Get a Free Quote Today
            </a>
            <a href="#services" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-md text-white border-2 border-white/20 hover:border-white hover:bg-white/5 transition-all" data-id="element-216" data-mp="x0crckc7ykh5">
              View Specialized Services
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}